import * as Images from './PermissionImages'

export const permissionStepsData = {
  DesktopChromeMicrophoneSteps: [
    {
      title: 'Step 1',
      image: Images.ChromeDesktopStepOne,
      instructions: "Click the 'Lock' icon that displays in the address bar on the left."
    },
    {
      title: 'Step 2',
      image: Images.ChromeDesktopMicStepTwo,
      instructions: "Turn on the slider after Microphone and close the menu via the 'x' button."
    },
    {
      title: 'Step 3',
      image: Images.ChromeDesktopStepFour,
      instructions: 'If asked, reload the webpage and your call should start to load and connect.'
    }
  ],
  DesktopChromeCameraSteps: [
    {
      title: 'Step 1',
      image: Images.ChromeDesktopStepOne,
      instructions: "Click the 'Lock' icon that displays in the address bar on the left."
    },
    {
      title: 'Step 2',
      image: Images.ChromeDesktopCamStepTwo,
      instructions: "Turn on the slider after Camera and close the menu via the 'x' button."
    },
    {
      title: 'Step 3',
      image: Images.ChromeDesktopStepFour,
      instructions: 'If asked, reload the webpage and your call should start to load and connect.'
    }
  ],
  //Android Systems Microphone
  AndroidSystemMicrophoneSteps: [
    {
      title: 'Step 1',
      image: Images.AndroidSystemStepOne,
      instructions: 'Open the Settings app on your phone and go to Apps or Apps and notifications.'
    },
    {
      title: 'Step 2',
      image: Images.AndroidSystemStepTwo,
      instructions: 'Scroll down to locate Chrome on the app list.'
    },
    {
      title: 'Step 3',
      image: Images.AndroidSystemStepThree,
      instructions: 'Next, go to Permissions. Here, you’ll find a list of permissions for Chrome. '
    },
    {
      title: 'Step 4',
      image: Images.AndroidSystemStepFourMic,
      instructions: 'Tap on the Microphone option and select Allow only while using the app.'
    }
  ],
  AndroidSystemCameraSteps: [
    {
      title: 'Step 1',
      image: Images.AndroidSystemStepOne,
      instructions: 'Open the Settings app on your phone and go to Apps or Apps and notifications.'
    },
    {
      title: 'Step 2',
      image: Images.AndroidSystemStepTwo,
      instructions: 'Scroll down to locate Chrome on the app list.'
    },
    {
      title: 'Step 3',
      image: Images.AndroidSystemStepThree,
      instructions: 'Next, go to Permissions. Here, you’ll find a list of permissions for Chrome. '
    },
    {
      title: 'Step 4',
      image: Images.AndroidSystemStepFourCam,
      instructions: 'Tap on the Camera option and select Allow only while using the app.'
    }
  ],
  AndroidChromeMicrophoneSteps: [
    {
      title: 'Step 1',
      image: Images.AndroidChromeStepOne,
      instructions: "Tap the 'Tune' icon that displays in the address bar on the left."
    },
    {
      title: 'Step 2',
      image: Images.AndroidChromeStepTwo,
      instructions: "Tap on 'Permissions' in the site information pop-up."
    },
    {
      title: 'Step 3',
      image: Images.AndroidChromeStepThreeMic,
      instructions:
        'Turn on the slider after Microphone and tap anywhere on the website (outside the Permissions panel).'
    },
    {
      title: 'Step 4',
      image: Images.AndroidChromeStepFourMic,
      instructions: 'Within the Microphone card, tap on the ‘Test Microphone Permissions’ button.'
    },
    {
      title: 'Step 5',
      image: Images.AndroidChromeStepFive,
      instructions: "A new Permission Granted card will appear. Tap on the 'Join Call' button."
    }
  ],
  AndroidChromeCameraSteps: [
    {
      title: 'Step 1',
      image: Images.AndroidChromeStepOne,
      instructions: "Tap the 'Tune' icon that displays in the address bar on the left."
    },
    {
      title: 'Step 2',
      image: Images.AndroidChromeStepTwo,
      instructions: "Tap on 'Permissions' in the site information pop-up."
    },
    {
      title: 'Step 3',
      image: Images.AndroidChromeStepThreeCam,
      instructions:
        'Turn on the slider after Camera and tap anywhere on the website (outside the Permissions panel).'
    },
    {
      title: 'Step 4',
      image: Images.AndroidChromeStepFourCam,
      instructions: 'Within the Camera card, tap on the ‘Test Camera Permissions’ button.'
    },
    {
      title: 'Step 5',
      image: Images.AndroidChromeStepFive,
      instructions: "A new Permission Granted card will appear. Tap on the 'Join Call' button."
    }
  ],
  MacSafariMicrophoneSettings: [
    {
      title: 'Step 1',
      image: Images.SafariDesktopStepOne,
      instructions: 'In Safari, choose Safari > Settings for rapid.liveswitch.com'
    },
    {
      title: 'Step 2',
      image: Images.SafariDesktopStepTwoMic,
      instructions: "Select the dropdown after Microphone and select 'Allow' from the list."
    },
    {
      title: 'Step 3',
      image: Images.SafariDesktopStepFour,
      instructions: 'Reload the webpage and your call should start to load and connect.'
    }
  ],
  MacSafariCameraSettings: [
    {
      title: 'Step 1',
      image: Images.SafariDesktopStepOne,
      instructions: 'In Safari, choose Safari > Settings for rapid.liveswitch.com'
    },
    {
      title: 'Step 2',
      image: Images.SafariDesktopStepTwoCam,
      instructions: "Select the dropdown after Camera and select 'Allow' from the list."
    },
    {
      title: 'Step 3',
      image: Images.SafariDesktopStepFour,
      instructions: 'Reload the webpage and your call should start to load and connect.'
    }
  ],
  macOSSystemChromeMicrophoneSteps: [
    {
      title: 'Step 1',
      image: Images.MacSystemStepOne,
      instructions: 'Click on the Apple logo in the top-left corner of the screen.'
    },
    {
      title: 'Step 2',
      image: Images.MacSystemStepTwo,
      instructions: "Click on 'System Settings'."
    },
    {
      title: 'Step 3',
      image: Images.MacSystemStepThree,
      instructions: "Click 'Privacy & Security' in the sidebar on the left."
    },
    {
      title: 'Step 4',
      image: Images.MacSystemStepFourMic,
      instructions: 'Click ‘Microphone’ in the list under Privacy on the right.'
    },
    {
      title: 'Step 5',
      image: Images.MacSystemStepFiveChromeMic,
      instructions: 'Turn on the microphone access for Google Chrome.'
    },
    {
      title: 'Step 6',
      image: Images.MacSystemStepSixChromeMic,
      instructions: 'Click ‘Quit & Reopen’ button to apply the changes.'
    }
  ],
  macOSSystemChromeCameraSteps: [
    {
      title: 'Step 1',
      image: Images.MacSystemStepOne,
      instructions: 'Click on the Apple logo in the top-left corner of the screen.'
    },
    {
      title: 'Step 2',
      image: Images.MacSystemStepTwo,
      instructions: "Click on 'System Settings'."
    },
    {
      title: 'Step 3',
      image: Images.MacSystemStepThree,
      instructions: "Click 'Privacy & Security' in the sidebar on the left."
    },
    {
      title: 'Step 4',
      image: Images.MacSystemStepFourCam,
      instructions: 'Click ‘Camera’ in the list under Privacy on the right.'
    },
    {
      title: 'Step 5',
      image: Images.MacSystemStepFiveChromeCam,
      instructions: 'Turn on the camera access for Google Chrome.'
    },
    {
      title: 'Step 6',
      image: Images.MacSystemStepSixChromeCam,
      instructions: 'Click ‘Quit & Reopen’ button to apply the changes.'
    }
  ],
  macOSSystemFirefoxMicrophoneSteps: [
    {
      title: 'Step 1',
      image: Images.MacSystemStepOne,
      instructions: 'Click on the Apple logo in the top-left corner of the screen.'
    },
    {
      title: 'Step 2',
      image: Images.MacSystemStepTwo,
      instructions: "Click on 'System Settings'."
    },
    {
      title: 'Step 3',
      image: Images.MacSystemStepThree,
      instructions: "Click 'Privacy & Security' in the sidebar on the left."
    },
    {
      title: 'Step 4',
      image: Images.MacSystemStepFourMic,
      instructions: 'Click ‘Microphone’ in the list under Privacy on the right.'
    },
    {
      title: 'Step 5',
      image: Images.MacSystemStepFiveFirefoxMic,
      instructions: 'Allow Firefox to access the microphone.'
    },
    {
      title: 'Step 6',
      image: Images.MacSystemStepSixFirefoxMic,
      instructions: 'Click ‘Quit & Reopen’ button to apply the changes.'
    }
  ],
  macOSSystemFirefoxCameraSteps: [
    {
      title: 'Step 1',
      image: Images.MacSystemStepOne,
      instructions: 'Click on the Apple logo in the top-left corner of the screen.'
    },
    {
      title: 'Step 2',
      image: Images.MacSystemStepTwo,
      instructions: "Click on 'System Settings'."
    },
    {
      title: 'Step 3',
      image: Images.MacSystemStepThree,
      instructions: "Click 'Privacy & Security' in the sidebar on the left."
    },
    {
      title: 'Step 4',
      image: Images.MacSystemStepFourCam,
      instructions: 'Click ‘Camera’ in the list under Privacy on the right.'
    },
    {
      title: 'Step 5',
      image: Images.MacSystemStepFiveFirefoxCam,
      instructions: 'Allow Firefox to access the camera.'
    },
    {
      title: 'Step 6',
      image: Images.MacSystemStepSixFirefoxCam,
      instructions: 'Click ‘Quit & Reopen’ button to apply the changes.'
    }
  ],
  DesktopFirefoxMicrophoneSettings: [
    {
      title: 'Step 1',
      image: Images.FirefoxDesktopStepOne,
      instructions: "Click the 'Permissions' icon that displays in the address bar on the left."
    },
    {
      title: 'Step 2',
      image: Images.FirefoxDesktopStepTwoMic,
      instructions:
        'Click the X next to Allowed, Allowed Temporarily, Blocked or Blocked Temporarily to clear the status so that Firefox will ask again for permission when you next visit the site.'
    },
    {
      title: 'Step 3',
      image: Images.FirefoxDesktopStepThree,
      instructions: 'Reload the page.'
    },
    {
      title: 'Step 4 ',
      image: Images.FirefoxDesktopStepFour,
      instructions: 'Allow Firefox to access the microphone.'
    },
    {
      title: 'Step 5',
      image: Images.FirefoxDesktopStepFive,
      instructions: 'Click ‘Allow’ and your call should start to load and connect.'
    }
  ],
  DesktopFirefoxCameraSettings: [
    {
      title: 'Step 1',
      image: Images.FirefoxDesktopStepOne,
      instructions: "Click the 'Permissions' icon that displays in the address bar on the left."
    },
    {
      title: 'Step 2',
      image: Images.FirefoxDesktopStepTwoCam,
      instructions:
        'Click the X next to Allowed, Allowed Temporarily, Blocked or Blocked Temporarily to clear the status so that Firefox will ask again for permission when you next visit the site.'
    },
    {
      title: 'Step 3',
      image: Images.FirefoxDesktopStepThree,
      instructions: 'Reload the page.'
    },
    {
      title: 'Step 4 ',
      image: Images.FirefoxDesktopStepFour,
      instructions: 'Allow Firefox to access the camera.'
    },
    {
      title: 'Step 5',
      image: Images.FirefoxDesktopStepFive,
      instructions: 'Click ‘Allow’ and your call should start to load and connect.'
    }
  ],
  IOSChromeCameraSettings: [
    {
      title: 'Step 1',
      image: Images.IosChromeStepOne,
      instructions: 'Click the three dots (...) in the right side of the bottom navigation bar.'
    },
    {
      title: 'Step 2',
      image: Images.IosChromeStepTwo,
      instructions: 'Tap the ‘Reload’ option from the list '
    },
    {
      title: 'Step 3',
      image: Images.IosChromeStepThree,
      instructions:
        'When prompted for camera and microphone permissions, click ‘Allow’ and your call should start to load and connect.'
    }
  ],
  IOSChromeMicrophoneSettings: [
    {
      title: 'Step 1',
      image: Images.IosChromeStepOne,
      instructions: 'Click the three dots (...) in the right side of the bottom navigation bar.'
    },
    {
      title: 'Step 2',
      image: Images.IosChromeStepTwo,
      instructions: 'Tap the ‘Reload’ option from the list '
    },
    {
      title: 'Step 3',
      image: Images.IosChromeStepThree,
      instructions:
        'When prompted for camera and microphone permissions, click ‘Allow’ and your call should start to load and connect.'
    }
  ],
  windowsSystemMicrophoneSettings: [
    {
      title: 'Step 1',
      image: Images.WindowsSystemStepOne,
      instructions: 'Select Start and select Settings.'
    },
    {
      title: 'Step 2',
      image: Images.WindowsSystemStepTwo,
      instructions: "Click 'Privacy & security' in the sidebar. (You may need to scroll down.)"
    },
    {
      title: 'Step 3',
      image: Images.WindowsSystemStepThreeMic,
      instructions: 'Click ‘Microphone’ in the list under Privacy & security > App permissions.'
    },
    {
      title: 'Step 4',
      image: Images.WindowsSystemStepFourMic,
      instructions:
        'Turn on access to the microphone by enabling the following three configurations: (1) Microphone access = On; (2) Let apps access your microphone = On; (3) Let desktop apps access your microphone = On.'
    }
  ],
  windowsSystemCameraSettings: [
    {
      title: 'Step 1',
      image: Images.WindowsSystemStepOne,
      instructions: 'Select Start and select Settings.'
    },
    {
      title: 'Step 2',
      image: Images.WindowsSystemStepTwo,
      instructions: "Click 'Privacy & security' in the sidebar. (You may need to scroll down.)"
    },
    {
      title: 'Step 3',
      image: Images.WindowsSystemStepThreeCam,
      instructions: 'Click ‘Camera’ in the list under Privacy & security > App permissions.'
    },
    {
      title: 'Step 4',
      image: Images.WindowsSystemStepFourCam,
      instructions:
        'Turn on access to the camera by enabling the following three configurations: (1) Camera access = On; (2) Let apps access your camera = On; (3) Let desktop apps access your camera = On.'
    }
  ],

  //IOS SAFARI
  IosSafariMicrophoneSteps: [
    {
      title: 'Step 1',
      image: Images.browserStepOne,
      instructions: 'Click on the browser menu.'
    },
    {
      title: 'Step 2',
      image: Images.browserStepTwo,
      instructions: 'Click website settings.'
    },
    {
      title: 'Step 3',
      image: Images.browserMicStepThree,
      instructions: 'Click on Microphone.'
    },
    {
      title: 'Step 4',
      image: Images.browserMicStepFour,
      instructions: 'Select the Allow option.'
    },
    {
      title: 'Step 5',
      image: Images.browserStepFive,
      instructions: 'Click done!'
    },
    {
      title: 'Step 6',
      button: true,
      instructions:
        'Click the Test Microphone Permissions button. If permissions are granted correctly, the red microphone icon above will turn green!'
    }
  ],
  IosSystemMicrophoneSteps: [
    {
      title: 'Step 1',
      image: Images.phoneStepOne,
      instructions: 'Find and open the settings app on your phones home screen.'
    },
    {
      title: 'Step 2',
      image: Images.phoneStepTwo,
      instructions: 'Find Safari and click it.'
    },
    {
      title: 'Step 3',
      image: Images.phoneMicStepThree,
      instructions: 'Click on Microphone.'
    },
    {
      title: 'Step 4',
      image: Images.phoneMicStepFour,
      instructions: 'Select the Allow option.'
    },
    {
      title: 'Step 5',
      button: true,
      instructions:
        'Click the Test Microphone Permissions button. If permissions are granted correctly, the red microphone icon above will turn green!'
    }
  ],
  IosSafariCameraSteps: [
    {
      title: 'Step 1',
      image: Images.browserStepOne,
      instructions: 'Click on the browser menu.'
    },
    {
      title: 'Step 2',
      image: Images.browserStepTwo,
      instructions: 'Click website settings.'
    },
    {
      title: 'Step 3',
      image: Images.browserCamStepThree,
      instructions: 'Click on Camera.'
    },
    {
      title: 'Step 4',
      image: Images.browserCamStepFour,
      instructions: 'Select the Allow option.'
    },
    {
      title: 'Step 5',
      image: Images.browserStepFive,
      instructions: 'Click done!'
    },
    {
      title: 'Step 6',
      button: true,
      instructions:
        'Click the Test Camera Permissions button. If permissions are granted correctly, the red camera icon above will turn green!'
    }
  ],
  IosSystemCameraSteps: [
    {
      title: 'Step 1',
      image: Images.phoneStepOne,
      instructions: 'Find and open the settings app on your phones home screen.'
    },
    {
      title: 'Step 2',
      image: Images.phoneStepTwo,
      instructions: 'Find Safari and click it.'
    },
    {
      title: 'Step 3',
      image: Images.phoneCamStepThree,
      instructions: 'Click on Camera.'
    },
    {
      title: 'Step 4',
      image: Images.phoneCamStepFour,
      instructions: 'Select the Allow option.'
    },
    {
      title: 'Step 5',
      instructions:
        'Click the Test Camera Permissions button. If permissions are granted correctly, the red camera icon above will turn green!'
    }
  ],
  macOSSystemMicrophoneSteps: [
    {
      instructions: "Please refer to the 'In Browser' settings above."
    }
  ],
  macOSSystemCameraSteps: [
    {
      instructions: "Please refer to the 'In Browser' settings above."
    }
  ]
}
